import { motion } from "motion/react";

import { useTheme } from "@up/data";

import { Toast, ToastTitle } from "./toast2/toast";

type Props = {
  error: string;
  errorCode?: number;
};

const MOTION = {
  props: {
    animate: {
      opacity: 1,
      rotate: 0,
      y: 0,
    },
    initial: {
      opacity: 0,
      rotate: -9,
      y: 100,
    },
    transition: {
      type: "spring",
      mass: 1,
      stiffness: 150,
    },
  },
};

export function LoadingError({ error, errorCode }: Props): JSX.Element {
  const theme = useTheme();

  return (
    <motion.div {...MOTION.props}>
      <Toast variant="error">
        <ToastTitle>
          {error}
          {errorCode ? `: Error code ${errorCode}` : null}
        </ToastTitle>
        Please try again later. If this error continues{" "}
        <a
          className="underline break-all"
          href={`mailto: ${theme.supportEmail}`}
        >
          contact us at {theme.supportEmail}
        </a>
        .
      </Toast>
    </motion.div>
  );
}
